module.exports = __webpack_public_path__ + "img/ads3.cee203ed.jpg";